// Short audio cues for headset mode. Synthesized with the Web Audio API so no
// sound asset is bundled. The context is created lazily and must be resumed
// from a user gesture (the headset-mode toggle) for later playback to be
// allowed by the browser's autoplay policy.

let context: AudioContext | null = null;

function ensureContext(): AudioContext | null {
	const Ctor =
		window.AudioContext ??
		(window as unknown as { webkitAudioContext?: typeof AudioContext })
			.webkitAudioContext;
	if (!Ctor) {
		return null;
	}
	context ??= new Ctor();
	return context;
}

/**
 * Create/resume the shared audio context. Call from a user gesture (e.g. the
 * headset-mode toggle) so browsers permit the acknowledgement sounds later.
 */
export function primeAudio(): void {
	const ctx = ensureContext();
	if (ctx && ctx.state === "suspended") {
		void ctx.resume();
	}
}

/** Play a short acknowledgement blip. */
export function playAcknowledgement(): void {
	const ctx = ensureContext();
	if (!ctx) {
		return;
	}
	if (ctx.state === "suspended") {
		void ctx.resume();
	}
	const now = ctx.currentTime;
	const oscillator = ctx.createOscillator();
	const gain = ctx.createGain();
	oscillator.type = "sine";
	oscillator.frequency.setValueAtTime(660, now);
	oscillator.frequency.exponentialRampToValueAtTime(990, now + 0.1);
	gain.gain.setValueAtTime(0, now);
	gain.gain.linearRampToValueAtTime(0.18, now + 0.01);
	gain.gain.exponentialRampToValueAtTime(0.001, now + 0.14);
	oscillator.connect(gain);
	gain.connect(ctx.destination);
	oscillator.start(now);
	oscillator.stop(now + 0.15);
}
